import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import jwt_decode from "jwt-decode";
import ModalForgotPassword from "../../../../../../shared/create-offer/ModalForgotPassword/ModalForgotPassword";
import InputForm from "../../../../../../shared/atoms/InputForm";
import {
	cpfMask,
	cnpjMask,
	patternOnlyNumbers,
	phoneNumberMask
} from "../../../../../../shared/create-offer/utils/masks";
import { getUserToken } from "../../../../../shared/utils";
import { Heading } from "@maxmilhas/hangar-components-atomic/public";
import Callout from "../../../../../../shared/create-offer/Callout/Callout";
import ModalLatamPhone from "../../../../../../shared/create-offer/ModalPhoneLatam/ModalLatamPhone";
import {
	GOL_ACRONYM,
	GOL_FIDELITY_PROGRAM,
	Type2FA,
	GOL_TWO_FACTOR_MESSAGE
} from "../../../../../../../js/shared/constants";
import Radio from "../../../../../../shared/Radio/Radio";
import ModalPhoneTwoFactorAuthentication from "../../../../../../shared/create-offer/ModalPhoneTwoFactorAuthentication/ModalPhoneTwoFactorAuthentication";
import ButtonLink from "../../../../../../../js/components/DynamicForm/components/ButtonLink";
import Button from "../../../../../../shared/button/button";

// Máximo de caracteres para senha da Smiles
const maxLengthPassSmiles = 4;

// Máximo de caracteres para senha da Latam Pass
const maxLengthPassMultiplus = 5;

// Debounce function
let timerId;
let fnWaiting;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	if (!fn && fnWaiting) fnWaiting();
	fnWaiting = fn;
	if (!fn) return;
	timerId = setTimeout(fn, delay);
};

class EditFidelityProgramDetails extends Component {
	constructor() {
		super();
		this.state = {
			user: "",
			password: "",
			lastName: "",
			pwAwardSecondary: "",
			phone: "",
			twoFactorAuthenticationStrategy: "",
			showModalTwoFactorAuthenticationPhone: false,
			isMaxPhone: 0,
			forgotPassword: false,
			showModalPhone: false,
			errors: [],
			international: false,
			debouncing: false,
			phoneFocus: false
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeRadio = this.onChangeRadio.bind(this);
		this.updateTwoFactorAuthenticationWhenAlreadyRegistered = this.updateTwoFactorAuthenticationWhenAlreadyRegistered.bind(this);
		this.setInfos = this.setInfos.bind(this);
		this.checkAllFilled = this.checkAllFilled.bind(this);
		this.requestTwoFactorCode = this.requestTwoFactorCode.bind(this);
	}

	setInfos(name, value) {
		this.setState({ [name]: value });
	}

	checkAllFilled(state = this.state) {
		const { checkData, fidelityProgram, status2FAEnabledFeature } = this.props;
		const { user, password, pwAwardSecondary, phone, twoFactorAuthenticationStrategy, errors, lastName, debouncing } = state;

		let fieldsIsCompleted = false;

		if (fidelityProgram.id === 3) {
			fieldsIsCompleted =
				pwAwardSecondary.length === maxLengthPassMultiplus &&
				!!phone.length &&
				!errors.pwAwardSecondary &&
				!errors.phone &&
				!debouncing;
		}

		if (fidelityProgram.id === 14) {
			fieldsIsCompleted = !!lastName.length && !debouncing;
		}

		if (fidelityProgram.id === GOL_FIDELITY_PROGRAM && status2FAEnabledFeature) {
			fieldsIsCompleted = !!twoFactorAuthenticationStrategy.length && !errors.twoFactorAuthenticationStrategy && !debouncing;
		}

		fieldsIsCompleted =
			fieldsIsCompleted &&
			!!user.length &&
			!!password.length &&
			!errors.user &&
			!errors.password &&
			!debouncing;

		checkData("completedBoxDataFidelityProgramDetails", fieldsIsCompleted);
	}

	componentWillMount() {
		const { fidelityProgram, userData, setData } = this.props;
		const { errors } = this.state;

		let boolInternational = fidelityProgram.international === "1";
		let user;
		let token = getUserToken();
		let payload = jwt_decode(token);

		if (!boolInternational) {
			user = payload.ssn
				.match(patternOnlyNumbers)
				.join("")
				.toString();
			setData({ user: user });
		} else {
			user = userData.username ? userData.username : "";
			setData({ user: user });
		}

		let password = userData.password ? userData.password : "";
		let pwAwardSecondary = userData.pwAwardSecondary ? userData.pwAwardSecondary : "";
		let phone = userData.phone ? userData.phone : "";
		let isMaxPhone = userData.isMaxPhone ? userData.isMaxPhone : 0;
		let lastName = fidelityProgram.id === 14 ? userData.lastName : null;
		let twoFactorAuthenticationStrategy = this.state.twoFactorAuthenticationStrategy ? this.state.twoFactorAuthenticationStrategy : "";

		this.setState({
			user: user,
			password: password,
			pwAwardSecondary: pwAwardSecondary,
			phone: phone,
			isMaxPhone,
			international: boolInternational,
			lastName,
			twoFactorAuthenticationStrategy: twoFactorAuthenticationStrategy,
			errors: {
				...errors,
				pwAwardSecondary: !!pwAwardSecondary && pwAwardSecondary.length !== maxLengthPassMultiplus
			}
		});

		if (fidelityProgram.id === GOL_FIDELITY_PROGRAM && !twoFactorAuthenticationStrategy.length) {
			this.setState({ errors: { ...errors, twoFactorAuthenticationStrategy: true } });
		}

		setTimeout(() => this.checkAllFilled(), 200);
	}

	componentWillUpdate(nextProps, nextState) {
		if (!nextState.debouncing && this.state.debouncing) {
			this.checkAllFilled(nextState);
		}
	}

	onChangePhone(value, phoneField) {
		const { setData, phoneMMSuggestion, fidelityProgram } = this.props;
		const { errors } = this.state;

		let phone = value.match(patternOnlyNumbers)
			? value
				.match(patternOnlyNumbers)
				.join("")
				.toString()
			: "";
		let isMaxPhone = phone == phoneMMSuggestion ? 1 : 0;

		this.setState({
			[`${phoneField}`]: value,
			isMaxPhone,
			errors: { ...errors, phone: false },
			debouncing: true
		});

		debounced(
			() =>
				this.setState({
					errors: { ...errors, phone: phone.length !== 11 || phone[2] !== "9" },
					debouncing: false
				}),
			1000
		);
		setData({
			[`${phoneField}`]: phone,
			isMaxPhone
		});
	}

	updateTwoFactorAuthenticationWhenAlreadyRegistered = strategyType => {
		const { setData } = this.props;
		const { errors, user } = this.state;

		this.setState({ twoFactorAuthenticationStrategy: strategyType, errors: { ...errors, twoFactorAuthenticationStrategy: !strategyType.length } });
		setData({ user: user, twoFactorAuthenticationStrategy: strategyType });
		setTimeout(() => this.checkAllFilled(), 200);
	};

	onChangeRadio = event => {
		const { setInputInFocus, setData } = this.props;
		const { errors } = this.state;
		const { value } = event;

		setInputInFocus("twoFactorAuthenticationStrategy");

		if (value === Type2FA.WHATSAPP_CONTACT) {
			this.setState({ showModalTwoFactorAuthenticationPhone: true });
		}

		this.setState({ twoFactorAuthenticationStrategy: value, errors: { ...errors, twoFactorAuthenticationStrategy: !value.length } });
		setData({ twoFactorAuthenticationStrategy: value });
		setTimeout(() => this.checkAllFilled(), 200);
	};

	onChange = event => {
		const { name, value } = event.target;
		const { international, errors } = this.state;
		const { fidelityProgram, setData } = this.props;
		let token = getUserToken();
		let payload = jwt_decode(token);

		switch (name) {
			case "user":
				let user = international
					? value
					: payload.ssn
						.match(patternOnlyNumbers)
						.join("")
						.toString();
				international && this.setState({ user: user, errors: { ...errors, user: !value.length } });
				setData({ [name]: user });
				break;
			case "lastName":
				let lastName = String(value).replace(/[0-9]/g, "");

				international &&
					this.setState({ lastName: lastName, errors: { ...errors, lastName: !value.length } });
				setData({ [name]: lastName });
				break;
			case "password":
				let password = value;
				if (fidelityProgram.id === 4) {
					password = value.match(patternOnlyNumbers)
						? value.match(patternOnlyNumbers).toString()
						: "";
					this.setState({
						password: password,
						errors: { ...errors, password: false },
						debouncing: true
					});
					debounced(
						() =>
							this.setState({
								errors: {
									...errors,
									password: password.length !== maxLengthPassSmiles
								},
								debouncing: false
							}),
						1000
					);
				} else {
					this.setState({
						password: password,
						errors: { ...errors, password: false },
						debouncing: true
					});
					debounced(
						() =>
							this.setState({
								errors: { ...errors, password: !password.length || password.length < 3 },
								debouncing: false
							}),
						1000
					);
				}
				setData({ [name]: password });
				break;
			case "pwAwardSecondary":
				let pwAwardSecondary = value.match(patternOnlyNumbers)
					? value.match(patternOnlyNumbers).toString()
					: "";
				this.setState({
					pwAwardSecondary: pwAwardSecondary,
					errors: { ...errors, pwAwardSecondary: false },
					debouncing: true
				});
				debounced(
					() =>
						this.setState({
							errors: {
								...errors,
								pwAwardSecondary: pwAwardSecondary.length !== maxLengthPassMultiplus
							},
							debouncing: false
						}),
					1000
				);
				setData({ [name]: pwAwardSecondary });
				break;
			case "phone":
				this.onChangePhone(value, "phone");
				break;
		}

		setTimeout(() => this.checkAllFilled(), 200);
	};

	requestTwoFactorCode = async () => {
		const { request2FACodeLatam, setHasClickedRequest2FACode } = this.props;
		setHasClickedRequest2FACode(true);
		await request2FACodeLatam();
	};

	render() {
		const {
			setInputInFocus,
			inputInFocus,
			phoneMMSuggestion,
			airlineProgramsSettings,
			offerData,
			email2FAStatusValidation,
			status2FAEnabledFeature,
			hasClickedRequest2FACode,
			hasTriedToProceedWithout2FA,
			twoFactorData
		} = this.props;
		const { id, fidelityName, acronym, linkPasswordRecovery } = this.props.fidelityProgram;
		const golAirlineProgramsSettings =
			airlineProgramsSettings &&
			Object.values(airlineProgramsSettings).find(
				item => item.idAirlinesProgram === GOL_FIDELITY_PROGRAM
			);

		const {
			user,
			lastName,
			password,
			pwAwardSecondary,
			phone,
			isMaxPhone,
			international,
			forgotPassword,
			showModalPhone,
			errors,
			twoFactorAuthenticationStrategy,
			showModalTwoFactorAuthenticationPhone,
		} = this.state;

		const ruleMaskInputUser = international ? undefined : user.length <= 11 ? cpfMask : cnpjMask;
		const typePhoneLatam = this.props.fidelityProgram.phoneRequiredMode;

		const shouldShow2FAButton = twoFactorData?.is2FAEnabled;

		return (
			<div className="edit-fidelity-program-and-bank-details">
				{/* <p className="edit-fidelity-program-and-bank-details--title">Dados da {fidelityName}</p> */}
				<Heading tag="h6">Dados da {fidelityName}</Heading>
				<form>
					<div className="row edit-fidelity-program-and-bank-details--row">
						<div className="col-xs-16">
							<InputForm
								name="user"
								id="user"
								value={user}
								onChange={this.onChange}
								mask={ruleMaskInputUser}
								onFocus={() => setInputInFocus("user")}
								placeholder=""
								disabled={!international}
								label={`${international ? "Usuário" : "CPF do titular"}`}
								hasError={errors.user}
							/>
						</div>
						{id == 14 && (
							<div className="col-xs-16">
								<InputForm
									name="lastName"
									id="lastName"
									value={lastName}
									onChange={this.onChange}
									onFocus={() => setInputInFocus("user")}
									placeholder=""
									disabled={!international}
									label="Sobrenome"
									hasError={errors.lastName}
								/>
							</div>
						)}
						<div className="col-xs-16">
							<InputForm
								autoComplete={international ? "new-password" : undefined}
								name="password"
								id="password"
								type="password"
								autocomplete="off"
								value={password}
								inputMode={id === 4 ? "tel" : undefined}
								maxLength={50}
								hasError={errors.password}
								onChange={this.onChange}
								onFocus={() => setInputInFocus("password")}
								onBlur={() => debounced(null)}
								placeholder=""
								label="Senha de acesso"
								errorMessage={`Senha inválida. ${id === 4
									? `A senha de acesso tem ${maxLengthPassSmiles} números.`
									: "O número de caracteres é insuficiente."
									}`}
								helperText={
									<CSSTransition
										in={inputInFocus === "password" && !!linkPasswordRecovery}
										unmountOnExit
										timeout={200}
										classNames="edit-fidelity-program-and-bank-details--forgot-password"
									>
										<div className="edit-fidelity-program-and-bank-details--forgot-password">
											<a
												onClick={() => this.setState({ forgotPassword: true })}
												data-action="forgot-password"
											>
												Esqueci minha senha
											</a>
										</div>
									</CSSTransition>
								}
								data-action="login-offer-password"
							/>
						</div>

						{shouldShow2FAButton && (
							<div className="col-xs-16 form-group">
								<Button
									onClick={this.requestTwoFactorCode}
									disabled={hasClickedRequest2FACode || !user || !password}
									className="btn-gray-md-o"
									type="button"
								>
									{twoFactorData.button?.text}
								</Button>
								<CSSTransition
									in={hasClickedRequest2FACode || hasTriedToProceedWithout2FA}
									unmountOnExit
									classNames="box-fidelity-program-details"
								>
									<div className="box-fidelity-program-details">
										<span
											className={
												hasClickedRequest2FACode
													? ""
													: "box-fidelity-program-details--error-message"
											}
										>
											{hasClickedRequest2FACode
												? twoFactorData.helpTextAfterClickButton
												: twoFactorData.helpTextBeforeClickButton}
										</span>
									</div>
								</CSSTransition>
							</div>
						)}

						{acronym === GOL_ACRONYM && id !== 3 ? (
							<div className="col-xs-16">
								<InputForm
									name="phone"
									id="phone"
									value={phone}
									type="tel"
									onChange={this.onChange}
									onBlur={() => debounced(null)}
									onFocus={() => setInputInFocus("phoneTwoFactorGol")}
									placeholder=""
									mask={phoneNumberMask}
									label="Telefone para autenticação"
									hasError={errors.phone}
									errorMessage={"Número de celular inválido"}
								/>
								<Callout
									show={inputInFocus === "phoneTwoFactorGol" || phone}
									warn
									style={{ marginBottom: "12px" }}
									text={<small>{GOL_TWO_FACTOR_MESSAGE}</small>}
								/>
								{id === GOL_FIDELITY_PROGRAM &&
									golAirlineProgramsSettings &&
									status2FAEnabledFeature && (
										<div className={`box-2fa`}>
											<p className="box-2fa--title box-title">{golAirlineProgramsSettings.title}</p>
											{golAirlineProgramsSettings.options.map(item => {
												!twoFactorAuthenticationStrategy &&
													item.selected &&
													this.updateTwoFactorAuthenticationWhenAlreadyRegistered(item?.type);
												return (
													<div className="row box-2fa__box-radio" key={item.type}>
														<div className="col">
															<p className="box-2fa--paragraph">
																{item.title}{" "}
																{item.tags.length > 0 && (
																	<span className="box-2fa__badge">{item.tags}</span>
																)}
															</p>
															<Radio
																horizontally={false}
																options={[
																	{
																		value: item.type,
																		label: item.description,
																		checked:
																			(!twoFactorAuthenticationStrategy && item.selected) ||
																			twoFactorAuthenticationStrategy === item.type
																	}
																]}
																name="twoFactorAuthenticationStrategy"
																value={twoFactorAuthenticationStrategy}
																onChange={this.onChangeRadio}
																errorMessage={errors.twoFactorAuthenticationStrategy}
															/>
															{item.actions?.length > 0 && (
																<div className="box-2fa__box-radio--small-font">
																	{!item.actions[0]?.disabled && (
																		<Callout
																			show={
																				(!twoFactorAuthenticationStrategy && item.selected) ||
																				twoFactorAuthenticationStrategy === item.type
																			}
																			hideIcon={true}
																			style={{ borderTop: "1px solid #E2E8F0" }}
																			text={
																				item.actions[0]?.text && (
																					<div className="no-padding-left">
																						<span>{item.actions[0]?.text}</span>
																						{item.actions[0]?.link && item.actions[0]?.textLink && (
																							<div className="mt-16 link-text-decoration-none">
																								<ButtonLink
																									color="green"
																									onClick={() =>
																										(window.open().location.href =
																											item.actions[0]?.link)
																									}
																								>
																									{item.actions[0]?.textLink}
																								</ButtonLink>
																							</div>
																						)}
																						{!item.actions[2]?.disabled && (
																							<div className={`mb-16 mt-16`}>
																								{item.actions[2]?.link &&
																									item.actions[2]?.textLink &&
																									((!email2FAStatusValidation.isValidated &&
																										email2FAStatusValidation.error !== null) ||
																										offerData.data.quant >=
																											item.actions[2]
																												?.minPointsToAlwaysShowButton) && (
																										<ButtonLink
																											color="green"
																											buttonStyle="outline"
																											onClick={() =>
																												(window.open().location.href =
																													item.actions[2].link)
																											}
																										>
																											{item.actions[2].textLink}
																										</ButtonLink>
																									)}
																							</div>
																						)}
																					</div>
																				)
																			}
																		/>
																	)}
																	{!item.actions[1]?.disabled && (
																		<>
																			{item.actions[1]?.text && (
																				<Callout
																					show={
																						(!twoFactorAuthenticationStrategy && item.selected) ||
																						twoFactorAuthenticationStrategy === item.type
																					}
																					hideIcon={true}
																					style={{ borderTop: "1px solid #E2E8F0" }}
																					text={<span>{item.actions[1]?.text}</span>}
																				/>
																			)}
																			{item.actions[1]?.link && item.actions[1]?.textLink && (
																				<div className="col-xs-16 mb-16">
																					<ButtonLink
																						color="green"
																						onClick={() =>
																							(window.open().location.href = item.actions[1].link)
																						}
																					>
																						{item.actions[1].textLink}
																					</ButtonLink>
																				</div>
																			)}
																		</>
																	)}
																</div>
															)}
														</div>
													</div>
												);
											})}
										</div>
									)}
							</div>
						) : null}
					</div>
					{id === 3 && (
						<>
							{typePhoneLatam !== 1 && (
								<div className="row edit-fidelity-program-and-bank-details--row">
									<div className="col-xs-16">
										<InputForm
											name="phone"
											id="phone"
											value={phone}
											type="tel"
											onChange={this.onChange}
											onFocus={e => {
												if (typePhoneLatam === 0 && !phone) {
													this.setInfos("showModalPhone", true);
												}
												setInputInFocus("phone");
											}}
											onBlur={() => debounced(null)}
											placeholder=""
											helperText={
												phone &&
												isMaxPhone == 1 &&
												typePhoneLatam === 0 && (
													<div className="edit-fidelity-program-and-bank-details--phone-chek">
														<i className="icon-check" />
														<p>Telefone confirmado</p>
													</div>
												)
											}
											mask={phoneNumberMask}
											label="Telefone no Latam Pass"
											hasError={typePhoneLatam === 0 && errors.phone}
											errorMessage="Número de celular inválido"
											data-action="login-offer-phone"
										/>
									</div>
								</div>
							)}
							{typePhoneLatam === 0 && (
								<>
									<Callout
										show={isMaxPhone == 0}
										criticalWarn
										text={
											<span>
												Atenção! É obrigatório adicionar o número de telefone celular da MaxMilhas
												no seu cadastro Latam Pass. Para alterar,{" "}
												<a onClick={() => this.setState({ showModalPhone: true })}>clique aqui</a>
												{"."}
											</span>
										}
									/>
									<Callout
										show={isMaxPhone == -1}
										criticalWarn
										text={
											<span>
												Este número foi desativado e deve ser alterado para outro telefone indicado
												pela MaxMilhas. Para alterar,{" "}
												<a onClick={() => this.setState({ showModalPhone: true })}>clique aqui</a>
											</span>
										}
									/>
								</>
							)}
						</>
					)}
				</form>
				<ModalForgotPassword
					linkPasswordRecovery={linkPasswordRecovery}
					show={forgotPassword}
					closeModal={this.setInfos}
				/>
				<ModalLatamPhone
					close={() => this.setInfos("showModalPhone", false)}
					show={showModalPhone}
					confirm={value => {
						this.setInfos("showModalPhone", false);
						this.onChangePhone(value);
					}}
					phoneSugestion={phoneMMSuggestion}
					phone={phone}
				/>
				<ModalPhoneTwoFactorAuthentication
					show={showModalTwoFactorAuthenticationPhone}
					onConfirm={() => this.setState({ showModalTwoFactorAuthenticationPhone: false })}
				/>
			</div>
		);
	}
}

EditFidelityProgramDetails.propTypes = {
	checkData: PropTypes.func,
	fidelityProgram: PropTypes.object.isRequired,
	inputInFocus: PropTypes.string,
	setData: PropTypes.func,
	setInputInFocus: PropTypes.func,
	userData: PropTypes.object.isRequired,
	phoneMMSuggestion: PropTypes.string
};

export default EditFidelityProgramDetails;
